import { render, staticRenderFns } from "./AdminActivityChart.vue?vue&type=template&id=23d6515f&scoped=true&"
import script from "./AdminActivityChart.vue?vue&type=script&lang=js&"
export * from "./AdminActivityChart.vue?vue&type=script&lang=js&"
import style0 from "./AdminActivityChart.vue?vue&type=style&index=0&id=23d6515f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d6515f",
  null
  
)

export default component.exports